module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-2",
    attrs: {
      "width": "100%"
    }
  }, [_c('v-card-title', [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    staticClass: "mb-2",
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("New template")]), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.formTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "disabled": !_vm.newTemplateValid
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Save")])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "icons-and-text": "",
      "centered": "",
      "color": "grey lighten-4"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "yellow"
    }
  }), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#tab-1"
    }
  }, [_vm._v("\n                Options\n                "), _c('v-icon', [_vm._v("settings_applications")])], 1), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#tab-2"
    }
  }, [_vm._v("\n                Items\n                "), _c('v-icon', [_vm._v("assignment")])], 1), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#tab-3"
    }
  }, [_vm._v("\n                Extras\n                "), _c('v-icon', [_vm._v("mdi-playlist-edit")])], 1), _vm._v(" "), _c('v-tab-item', {
    staticClass: "pa-2",
    attrs: {
      "value": "tab-1"
    }
  }, [_c('v-form', {
    ref: "newTemplate",
    model: {
      value: (_vm.newTemplateValid),
      callback: function($$v) {
        _vm.newTemplateValid = $$v
      },
      expression: "newTemplateValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Template Name",
      "rules": [function (v) { return !!v || 'Name is required'; }],
      "required": ""
    },
    model: {
      value: (_vm.editedItem.name),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "name", $$v)
      },
      expression: "editedItem.name"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Optional"
    },
    model: {
      value: (_vm.editedItem.optional),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "optional", $$v)
      },
      expression: "editedItem.optional"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Default for new job"
    },
    model: {
      value: (_vm.editedItem.required),
      callback: function($$v) {
        _vm.$set(_vm.editedItem, "required", $$v)
      },
      expression: "editedItem.required"
    }
  })], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    staticClass: "pa-2",
    attrs: {
      "value": "tab-2"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n                  Add New Item\n                ")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Item Title"
    },
    model: {
      value: (_vm.newTemplateItem.title),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateItem, "title", $$v)
      },
      expression: "newTemplateItem.title"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Item Text"
    },
    model: {
      value: (_vm.newTemplateItem.text),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateItem, "text", $$v)
      },
      expression: "newTemplateItem.text"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Optional"
    },
    model: {
      value: (_vm.newTemplateItem.optional),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateItem, "optional", $$v)
      },
      expression: "newTemplateItem.optional"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Web Service Test"
    },
    on: {
      "change": function($event) {
        _vm.newTemplateItem.photo = false
      }
    },
    model: {
      value: (_vm.newTemplateItem.test),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateItem, "test", $$v)
      },
      expression: "newTemplateItem.test"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "disabled": _vm.newTemplateItem.test,
      "label": "Image"
    },
    model: {
      value: (_vm.newTemplateItem.photo),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateItem, "photo", $$v)
      },
      expression: "newTemplateItem.photo"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [(_vm.editItemIndex === -1) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addNewTemplateItem()
      }
    }
  }, [_vm._v("Add")]) : _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addNewTemplateItem()
      }
    }
  }, [_vm._v("Edit")]), _vm._v(" "), (_vm.editItemIndex !== -1) ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.cancelItem()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "avatar": ""
    }
  }, [_vm._l((_vm.editedItem.items), function(item, index) {
    return [(index > 0) ? _c('v-divider') : _c('v-subheader', [_vm._v("Template Items")]), _vm._v(" "), _c('v-list-tile', {
      key: index
    }, [_c('v-list-tile-action', [(index > 0) ? _c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveTemplateItemUp(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("keyboard_arrow_up")])], 1) : _vm._e(), _vm._v(" "), (index < 1 || index >= _vm.editedItem.items.length - 1) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (index < _vm.editedItem.items.length - 1) ? _c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveTemplateItemDown(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("keyboard_arrow_down")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "icon": ""
      },
      domProps: {
        "innerHTML": _vm._s(item.photo ? 'add_a_photo' : 'description')
      }
    }), _vm._v(" "), _c('v-icon', {
      attrs: {
        "icon": ""
      },
      domProps: {
        "innerHTML": _vm._s(item.optional ? '' : 'visibility')
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.newTemplateItem = JSON.parse(JSON.stringify(_vm.editedItem.items[index]));
          _vm.editItemIndex = index
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "teal"
      }
    }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editedItem.items.splice(index, 1)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "pink"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-tab-item', {
    staticClass: "pa-2",
    attrs: {
      "value": "tab-3"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n                  Add New Extra\n                ")]), _vm._v(" "), _c('v-card-text', [_c('v-combobox', {
    attrs: {
      "label": "Item Title",
      "items": _vm.extrasList,
      "readonly": _vm.newTemplateExtra.type === 'sim'
    },
    model: {
      value: (_vm.newTemplateExtra.name),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateExtra, "name", $$v)
      },
      expression: "newTemplateExtra.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Default"
    },
    model: {
      value: (_vm.newTemplateExtra.default),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateExtra, "default", $$v)
      },
      expression: "newTemplateExtra.default"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Item Type",
      "items": ['uid', 'sim', 'choice', 'text', 'number']
    },
    model: {
      value: (_vm.newTemplateExtra.type),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateExtra, "type", $$v)
      },
      expression: "newTemplateExtra.type"
    }
  }), _vm._v(" "), (_vm.newTemplateExtra.type == 'number') ? _c('v-text-field', {
    attrs: {
      "label": "Step",
      "type": "number"
    },
    model: {
      value: (_vm.newTemplateExtra.step),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateExtra, "step", $$v)
      },
      expression: "newTemplateExtra.step"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newTemplateExtra.type == 'choice') ? _c('v-combobox', {
    attrs: {
      "label": "Item Options",
      "multiple": "",
      "chips": "",
      "deletable-chips": ""
    },
    model: {
      value: (_vm.newTemplateExtra.options),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateExtra, "options", $$v)
      },
      expression: "newTemplateExtra.options"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Required",
      "readonly": _vm.newTemplateExtra.type === 'uid'
    },
    model: {
      value: (_vm.newTemplateExtra.required),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateExtra, "required", $$v)
      },
      expression: "newTemplateExtra.required"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Customer Permissions",
      "items": ['none', 'read', 'write']
    },
    model: {
      value: (_vm.newTemplateExtra.permissions.customer),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateExtra.permissions, "customer", $$v)
      },
      expression: "newTemplateExtra.permissions.customer"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Sales Permissions",
      "items": ['none', 'read', 'write']
    },
    model: {
      value: (_vm.newTemplateExtra.permissions.sales),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateExtra.permissions, "sales", $$v)
      },
      expression: "newTemplateExtra.permissions.sales"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Support Permissions",
      "items": ['none', 'read', 'write']
    },
    model: {
      value: (_vm.newTemplateExtra.permissions.support),
      callback: function($$v) {
        _vm.$set(_vm.newTemplateExtra.permissions, "support", $$v)
      },
      expression: "newTemplateExtra.permissions.support"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [(_vm.editExtraIndex === -1) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addNewTemplateExtra()
      }
    }
  }, [_vm._v("Add")]) : _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addNewTemplateExtra()
      }
    }
  }, [_vm._v("Edit")]), _vm._v(" "), (_vm.editExtraIndex !== -1) ? _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.cancelExtra()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "avatar": ""
    }
  }, [_vm._l((_vm.editedItem.extras), function(item, index) {
    return [(index > 0) ? _c('v-divider') : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [(index > 0) ? _c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveExtraUp(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("keyboard_arrow_up")])], 1) : _vm._e(), _vm._v(" "), (index < 1 || index >= _vm.editedItem.extras.length - 1) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (index < _vm.editedItem.extras.length - 1) ? _c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveExtraDown(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("keyboard_arrow_down")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(item.type)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.newTemplateExtra = JSON.parse(JSON.stringify(_vm.editedItem.extras[index]));
          _vm.editExtraIndex = index
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "teal"
      }
    }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editedItem.extras.splice(index, 1)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "pink"
      }
    }, [_vm._v("delete")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-list', [_vm._l((_vm.templates), function(item, i) {
    return [_c('v-list-tile', {
      key: i,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-action', [(i > 0) ? _c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveItemUp(item)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("keyboard_arrow_up")])], 1) : _vm._e(), _vm._v(" "), (i < 1 || i >= _vm.templates.length - 1) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (i < _vm.templates.length - 1) ? _c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.moveItemDown(item)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("keyboard_arrow_down")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      staticClass: "mx-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.editItem(item)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "teal"
      }
    }, [_vm._v("edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider')]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-746d1c93","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Device.vue
// module id = 755
// module chunks = 1